import React, { useState, FC } from 'react';
import ReactSelect from 'react-select';
import classNames from 'classnames';

import classes from './ModalWorkplace.module.scss';
import modalBase from '../../../ModalBase/ModalBase.module.scss';
import { useGetWorkplacesList } from '../../../../hooks/MainLayout/useGetWokplacesList';
import { usePutUserAuthInfo } from '../../../../hooks/MainLayout/usePutUserAuthInfo';
import { FormatOptionLabel } from './WorkPlaceOption';
import { getOperatorQueueName } from '../../../../constants/HeadersAPI';
import { useLogout } from '../../../../hooks/Authorization/useLogout';

type ModalWorkplaceProps = {
  isActive: boolean;
  setActiveModal?: (value: boolean) => void;
  setWorkPlaceSelected: (value: boolean) => void;
  setIsAuthenticated: (status: boolean) => void;
  setWorkplaceName?: (value: string | null) => void;
  setWorkplaceDescription?: (value: string | null) => void;
};

export type ModalWorkplaceOptionType = {
  label: string;
  value: number;
  locked: boolean;
  serviceUnitName?: string;
  description?: string;
};

const customStyles = {
  control: (base) => ({
    ...base,
    height: 60,
    minHieght: 60,
    widht: 680,
    minWidth: 680,
    textTransform: 'uppercase',
    cursor: 'pointer'
  }),
  option: (base) => ({
    ...base,
    backgroundColor: 'white',
    color: 'black',
    textTransform: 'uppercase',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: '#d9ebffcc'
    }
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: 240,
    overflowY: 'auto'
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999
  })
};

const ModalWorkplace: FC<ModalWorkplaceProps> = ({
  isActive,
  setActiveModal,
  setWorkPlaceSelected,
  setIsAuthenticated,
  setWorkplaceName,
  setWorkplaceDescription
}) => {
  const [selectValue, setSelectValue] = useState<ModalWorkplaceOptionType | null>(null);
  const [lockedTip, setLockedTip] = useState<null | number>(null);
  const menuPortalTarget = typeof window !== 'undefined' ? document.body : undefined;
  const queueNameFromUrl = getOperatorQueueName();

  const { userWorkplacesResp } = useGetWorkplacesList(queueNameFromUrl);
  const { logout } = useLogout(setIsAuthenticated);
  const hasWorkplaces = Boolean(userWorkplacesResp?.length);

  const { putUserAuthInfo, isLoadingPutUserAuthInfo } = usePutUserAuthInfo(
    setWorkPlaceSelected,
    setActiveModal
  );

  const handleSubmit = () => {
    if (!selectValue.locked) {
      const name = (selectValue.serviceUnitName || '').trim() || null;
      const description = (selectValue.description || '').trim() || null;
      const label = (selectValue.label || '').trim() || null;
      if (name || description || label) {
        localStorage.setItem(
          'workplace',
          JSON.stringify({ id: selectValue.value, name, description, label })
        );
      } else {
        localStorage.removeItem('workplace');
      }
      setWorkplaceName?.(name);
      setWorkplaceDescription?.(description);
      putUserAuthInfo({ serviceUnitId: selectValue.value });
    }
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <div
      className={classNames(
        modalBase.modal,
        { [modalBase.active]: isActive },
        { [classes.load]: isLoadingPutUserAuthInfo }
      )}>
      <div className={classNames(modalBase.container, classes.modalContainer)}>
        <h2 className={modalBase.title}>Выберите рабочее место</h2>
        {queueNameFromUrl && (
          <div className={classes.queueHint}>Очередь: {queueNameFromUrl}</div>
        )}
        {lockedTip && (
          <div className={classes.lockedTip}>Рабочее место занято другим оператором</div>
        )}
        <div className={classes.selectContainer}>
          {hasWorkplaces && (
            <ReactSelect
              placeholder={''}
              noOptionsMessage={() => 'Выберите рабочее место'}
              options={userWorkplacesResp}
              formatOptionLabel={(option) => (
                <FormatOptionLabel setLockedTip={setLockedTip} optionValue={option} />
              )}
              isOptionDisabled={(option) => option.locked}
              styles={customStyles}
              menuPlacement="auto"
              menuPosition="fixed"
              menuPortalTarget={menuPortalTarget}
              maxMenuHeight={240}
              onChange={(value) => setSelectValue(value)}
              onMenuClose={() => setLockedTip(null)}
            />
          )}
        </div>
        <div className={classes.btnContainer}>
          {hasWorkplaces ? (
            <button
              className={classes.btn}
              onClick={() => handleSubmit()}
              disabled={!selectValue || isLoadingPutUserAuthInfo}>
              готово
            </button>
          ) : (
            <button
              className={classes.btn}
              onClick={handleLogout}
              disabled={isLoadingPutUserAuthInfo}>
              выйти
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalWorkplace;
